/**
 * DevExtreme (esm/renovation/ui/scheduler/workspaces/base/layout_props.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var LayoutProps = {
    viewData: Object.freeze({
        groupedData: [],
        leftVirtualCellCount: 0,
        rightVirtualCellCount: 0,
        topVirtualRowCount: 0,
        bottomVirtualRowCount: 0
    }),
    leftVirtualCellWidth: 0,
    rightVirtualCellWidth: 0,
    topVirtualRowHeight: 0,
    bottomVirtualRowHeight: 0,
    addDateTableClass: true,
    addVerticalSizesClassToRows: true
};
